import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, onMounted } from "vue";
import { thirdPartyService } from "@/services/internal-api/thirdparty.service";
import store from "@/state/store";
import { helpers } from "@/services/helpers";
import Loader from "@/components/widgets/loader.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'member-referral',
  setup(__props) {

const baseLink = "https://trykcm.com/referral/";

const link = ref("");

const error = ref("");
const dismissCountDown = ref(0);
const dismissSecs = ref(5);
const idFail = ref(false);
const isLoading = ref(true);

async function getHubspotRecordId(): Promise<void> {
  if (store.getters["crm/hubspotId"]) {
    link.value = baseLink + store.getters["crm/hubspotId"];
    return;
  }
  const hubspotContact = await thirdPartyService
    .get(
      "/hubspot/v1/contact/" +
        store.getters["auth/authEmail"] +
        "?fields=hs_object_id"
    )
    .catch((err) => {
      helpers.customSentryError(
        "Getting hubspot data",
        "Failed to get hubspot contact data for refer-friend",
        { error: err }
      );

      error.value = "Sorry, failed to create referral link at this time.";
      idFail.value = true;
    });

  if (hubspotContact) {
    const hubspotId = hubspotContact.data?.properties?.hs_object_id
      ? hubspotContact.data.properties?.hs_object_id
      : "";
    store.dispatch("crm/setHubspotId", hubspotId);
    link.value = baseLink + hubspotId;
  }
}

const copyLink = (): void => {
  error.value = "";
  try {
    navigator.clipboard.writeText(link.value);
  } catch (err) {
    error.value = "Unable to copy to clipboard.";
  }
  dismissCountDown.value = dismissSecs.value;
};

const countDownChanged = (countDown: number): void => {
  dismissCountDown.value = countDown;
};

const alertVariant = computed((): string => {
  return error.value === "" ? "success" : "danger";
});
const alertMessage = computed((): string => {
  return error.value === "" ? "Copied to clipboard!" : error.value;
});

onMounted(async () => {
  await getHubspotRecordId();
  isLoading.value = false;
});

return { __sfc: true,baseLink, link, error, dismissCountDown, dismissSecs, idFail, isLoading, getHubspotRecordId, copyLink, countDownChanged, alertVariant, alertMessage, Loader }
}

})